module.exports = __webpack_public_path__ + "img/up.9a14ca8b.svg";